import { Box, Typography } from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PLOTS_STATUS } from 'cml-script';
import React from 'react';
export const ALL_STATUS = {
  value: 'all',
  label: 'All',
};
export default function FilterPlotStatus({ value, onChange }) {
  return (
    <Box
      sx={{
        px: '22px',
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 'bold',
        }}
      >
        Plot Status
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          flexWrap: 'wrap',
        }}
      >
        {[ALL_STATUS, ...PLOTS_STATUS]
          .sort((a, b) => a.label.length - b.label.length)
          .map((item, index) => {
            // if (item.value === 1) return null;
            return (
              <Box key={index}>
                <Box
                  onClick={() => {
                    onChange(item.value);
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    borderRadius: '30px',
                    justifyContent: 'space-between',
                    px: '20px',
                    py: '6px',
                    border: '1px solid',
                    position: 'relative',
                    fontSize: '12px',
                    fontWeight: '600',
                    borderColor:
                      value === item.value ? 'primary.main' : 'divider',
                    bgcolor:
                      value === item.value ? 'primary.main' : 'transparent',
                    color: value === item.value ? 'white' : 'black',
                  }}
                >
                  <CheckCircleIcon
                    sx={{
                      display: value === item.value ? 'block' : 'none',
                      color: 'white',
                      position: 'absolute',
                      left: '2px',
                      width: '16px',
                    }}
                  />
                  {item.label}
                </Box>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
}
